import { AxiosError } from 'axios';
import Orders from '../symbols/orders';
import { HttpRequestPost } from '../../service';

const ordersSymbolsSetSelectedTabAction = (selected: number) => ({
  type: Orders.SET_SELECTED_TAB,
  payload: selected
});

export function setSelectedOrderTab(selected: number) {
  return (dispatch: any) => {
    dispatch(ordersSymbolsSetSelectedTabAction(selected));
  };
}

interface IAcceptOrkestroOrderRequestModel {
  DeliveryId: string;
  VehicleTypeId: number;
  PickupInstructions?: string;
}
interface IAcceptOrkestroOrderResponse {
  Result: string;
  Route: string;
}

export function acceptOrkestroOrder(
  body: IAcceptOrkestroOrderRequestModel,
  success: (result: string) => void,
  failure: Function
): void {
  HttpRequestPost(
    `/shop/delivery/accept`,
    () => undefined,
    (response: IAcceptOrkestroOrderResponse) => success(response.Result),
    (error: AxiosError<any>) => failure(error),
    true,
    body
  );
}

export function rejectOrkestroOrder(deliveryId: string, success: Function, failure: Function) {
  HttpRequestPost(
    `/portal/delivery/${deliveryId}/reject`,
    () => undefined,
    (response: IAcceptOrkestroOrderResponse) => success(response.Result),
    (error: AxiosError<any>) => error && failure(error),
    true,
    {}
  )
};
